import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { addToFavorites } from '../../actions/favorites';
import { showSnack } from '../../actions/uiActions';
import { getCurrentPattern } from '../../reducers/currentPattern';
import { getCurrentPatternDesigner } from '../../reducers/designer';
import { getMessage } from '../../reducers/i18n';
import { getCurrentQueryObject, getCurrentUri } from '../../reducers/page';
import { getActiveSewpat } from '../../reducers/sewpats';
import ShareLinkIcon from '../sharing/ShareLinkIcon';

import SnackBar from '../SnackBar';
import Spacer from '../styles/Spacer';
import AddToFavorites from './AddToFavorites';

const ActionBar = ({ pattern, query, addToFavoriteSnack, addToFavorites, shareUri, shareLinkLabel, addToFavoritesLabel, designer, sewpatId }) => {
    const handleAddToFavorites = () => {
        addToFavorites(pattern.id, sewpatId, query);
        addToFavoriteSnack(Date.now());
    };

    const shareLinkProps = {
        name: 'icon-link',
        width: '1.3em',
        height: '1.3em',
        iconColor: 'blueGrey.700',
    };

    const StyledPatternActionBarWrapper = styled.div`
        &.stolo-actionbar-wrapper {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          align-items: flex-start;
        }
    `;

    return (
        <StyledPatternActionBarWrapper className='stolo-actionbar-wrapper'>
            <ShareLinkIcon
                label={shareLinkLabel} direction='right' shareTarget={shareUri}
                iconProps={shareLinkProps}
            />
            <Spacer space={6} />
            <AddToFavorites
                addToFavorites={handleAddToFavorites}
                label={addToFavoritesLabel}
            />
            <SnackBar />
        </StyledPatternActionBarWrapper>
    );
};

const mapDispatchToProps = dispatch => (
    {
        addToFavoriteSnack: id => dispatch(showSnack(
            id,
            'SNACK_PATTERN_ADDED_TO_FAVORITES',
            null,
            2000,
            null,
        )),
        addToFavorites: (patternid, sewpatId, query) => dispatch(
            addToFavorites(patternid, sewpatId, query)),
    }
);

const makeMapStateToProps = (initialState, initialOwnProps) => {
    const shareLinkLabel = getMessage(initialState, initialOwnProps.messageId ||
        'SHARE_COPY_LINK_BUTTON_LABEL');
    const addToFavoritesLabel = getMessage(
        initialState,
        'ICON_LABEL_ADDTOFAVORITES',
    );
    const sewpat = getActiveSewpat(initialState);
    const sewpatId = sewpat.id;
    const mapStateToProps = state => (
        {
            pattern: getCurrentPattern(state),
            query: getCurrentQueryObject(state) || {},
            shareUri: getCurrentUri(state),
            shareLinkLabel,
            addToFavoritesLabel,
            designer: getCurrentPatternDesigner(state),
            sewpatId,
        }
    );
    return mapStateToProps;
};

export default connect(makeMapStateToProps, mapDispatchToProps)(ActionBar);



// WEBPACK FOOTER //
// ./src/components/pattern/ActionBar.js